import {
    DEFAULT_ADMINISTRATIVE_AND_FUNCTIONAL_ZONE_GUIDE_FILTER,
    DEFAULT_ADMINISTRATIVE_ROLE_GUIDE_FILTER,
    DEFAULT_INDIVIDUALS_GUIDE_FILTER,
    DEFAULT_MEASUREMENT_OKEI_GUIDE_FILTER,
    DEFAULT_MEASUREMENT_UNIT_GUIDE_FILTER,
    DEFAULT_NOMENCLATURE_GUIDE_FILTER,
    DEFAULT_PRODUCTION_ORDER_ARCHIVE_FILTER,
    DEFAULT_PRODUCTION_ORDER_EXECUTION_JOURNAL_FILTER,
    DEFAULT_PRODUCTION_ORDER_JOURNAL_FILTER,
    DEFAULT_PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER,
    DEFAULT_PRODUCTION_STAGE_GUIDE_FILTER,
    DEFAULT_TECHNOLOGICAL_OPERATION_GUIDE_FILTER,
    DEFAULT_TECHNOLOGICAL_PROCESS_CHART_GUIDE_FILTER,
    DEFAULT_USER_GUIDE_FILTER, DEFAULT_LOGS_FILTER
} from "./DefaultFilters";
import {UserGuideFilter} from "../users/UserGuideFilter";
import {NomenclatureGuideFilter} from "../nomenclature/NomenclatureGuideFilter";
import {ProductionOrderExecutionJournalFilter} from "../production-order-execution/ProductionOrderExecution";
import {
    AdministrativeAndFunctionalZoneGuideFilter
} from "../administrative-and-functional-zone/AdministrativeAndFunctionalZoneGuideFilter";
import {MeasurementGuideFilter} from "../measurement/MeasurementGuideFilter";
import {IndividualsGuideFilter} from "../individuals/Individuals";
import {GuideFilter} from "./GuideFilter";
import {TechnologicalProcessChartGuideFilter} from "../technological-process-chart/TechnologicalProcessChart";
import {AdministrativeRoleGuideFilter} from "../administrative-roles/AdministrativeRole";
import {ProductionStageGuideFilter} from "../production-stage/ProductionStage";
import {TechnologicalOperationGuideFilter} from "../technological-operation/TechnologicalOperationGuideFilter";
import {ProductionOrderJournalFilter} from "../production-order/ProductionOrder";
import {MeasurementOkeiGuideFilter} from "../measurement/MeasurementOkeiGuideFilter";
import {
    ProductionOrderAnalysisByTimeReportFilter
} from "../production-order-analysis-by-time/ProductionOrderAnalysisByTime";
import {LogsGuideFilter} from "../logs/Logs";

export enum TableFilterKey {
    NOMENCLATURE_GUIDE_FILTER = 'nomenclatureGuideFilter',
    USER_GUIDE_FILTER = 'userGuideFilter',
    PRODUCTION_ORDER_EXECUTION_JOURNAL_FILTER = 'production-orderExecutionDocument-journalFilter',
    INDIVIDUALS_GUIDE_FILTER = 'individualsGuideFilter',

    MEASUREMENT_UNIT_GUIDE_FILTER = 'measurement-unitGuideFilter',
    MEASUREMENT_OKEI_GUIDE_FILTER = 'measurement-okeiGuideFilter',
    ADMINISTRATIVE_ROLE_GUIDE_FILTER = 'administrative-rolesGuideFilter',
    TECHNOLOGICAL_PROCESS_CHART_GUIDE_FILTER = 'technological-process-chartGuideFilter',
    PRODUCTION_STAGE_GUIDE_FILTER = 'production-stagesGuideFilter',
    TECHNOLOGICAL_OPERATION_GUIDE_FILTER = 'technological-operationGuideFilter',
    ADMINISTRATIVE_AND_FUNCTIONAL_ZONE_GUIDE_FILTER = 'administrative-and-functional-zoneGuideFilter',
    PRODUCTION_ORDER_JOURNAL_FILTER = 'production-orderDocument-journalFilter',
    PRODUCTION_ORDER_ARCHIVE_FILTER = 'production-orderArchiveDocument-journalFilter',
    PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER = 'production-orderAnalysis-execution-by-timeReportFilter',
    LOGS_FILTER = 'logsReportFilter',
}

export function getFilterType(filterKey: TableFilterKey) {
    if (filterKey === TableFilterKey.USER_GUIDE_FILTER) {
        return DEFAULT_USER_GUIDE_FILTER;
    }
    if (filterKey === TableFilterKey.NOMENCLATURE_GUIDE_FILTER) {
        return DEFAULT_NOMENCLATURE_GUIDE_FILTER;
    }
    if (filterKey === TableFilterKey.PRODUCTION_ORDER_EXECUTION_JOURNAL_FILTER) {
        return DEFAULT_PRODUCTION_ORDER_EXECUTION_JOURNAL_FILTER;
    }
    if (filterKey === TableFilterKey.INDIVIDUALS_GUIDE_FILTER) {
        return DEFAULT_INDIVIDUALS_GUIDE_FILTER;
    }
    if (filterKey === TableFilterKey.ADMINISTRATIVE_ROLE_GUIDE_FILTER) {
        return DEFAULT_ADMINISTRATIVE_ROLE_GUIDE_FILTER;
    }
    if (filterKey === TableFilterKey.TECHNOLOGICAL_PROCESS_CHART_GUIDE_FILTER) {
        return DEFAULT_TECHNOLOGICAL_PROCESS_CHART_GUIDE_FILTER;
    }
    if (filterKey === TableFilterKey.PRODUCTION_STAGE_GUIDE_FILTER) {
        return DEFAULT_PRODUCTION_STAGE_GUIDE_FILTER;
    }
    if (filterKey === TableFilterKey.TECHNOLOGICAL_OPERATION_GUIDE_FILTER) {
        return DEFAULT_TECHNOLOGICAL_OPERATION_GUIDE_FILTER;
    }
    if (filterKey === TableFilterKey.ADMINISTRATIVE_AND_FUNCTIONAL_ZONE_GUIDE_FILTER) {
        return DEFAULT_ADMINISTRATIVE_AND_FUNCTIONAL_ZONE_GUIDE_FILTER;
    }
    if (filterKey === TableFilterKey.PRODUCTION_ORDER_JOURNAL_FILTER) {
        return DEFAULT_PRODUCTION_ORDER_JOURNAL_FILTER;
    }
    if (filterKey === TableFilterKey.MEASUREMENT_UNIT_GUIDE_FILTER) {
        return DEFAULT_MEASUREMENT_UNIT_GUIDE_FILTER;
    }
    if (filterKey === TableFilterKey.MEASUREMENT_OKEI_GUIDE_FILTER) {
        return DEFAULT_MEASUREMENT_OKEI_GUIDE_FILTER;
    }
    if (filterKey === TableFilterKey.PRODUCTION_ORDER_ARCHIVE_FILTER) {
        return DEFAULT_PRODUCTION_ORDER_ARCHIVE_FILTER;
    }
    if (filterKey === TableFilterKey.PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER) {
        return DEFAULT_PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER;
    }
    if (filterKey === TableFilterKey.LOGS_FILTER) {
        return DEFAULT_LOGS_FILTER;
    }
}

export type TableFilterType = UserGuideFilter | NomenclatureGuideFilter | ProductionOrderExecutionJournalFilter | AdministrativeAndFunctionalZoneGuideFilter | MeasurementGuideFilter | IndividualsGuideFilter | TechnologicalProcessChartGuideFilter | GuideFilter | AdministrativeRoleGuideFilter | ProductionStageGuideFilter | TechnologicalOperationGuideFilter | ProductionOrderJournalFilter | MeasurementOkeiGuideFilter | ProductionOrderAnalysisByTimeReportFilter | LogsGuideFilter;
